module.exports = __webpack_public_path__ + "img/quemsomos-1.9c37a796.jpg";